import { APIPerspectiveAttributes } from '@ardoq/api-types';
import { fetchEntities } from './api';

export const perspectiveApi = {
  fetch: fetchEntities<APIPerspectiveAttributes>('perspective'),
};
